import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Addfiles from "../../common/Addfiles";

export function InvoiceStep4CloseAdjudication(props) {

const [response, setResponse] = useState(null);
const [notes, setNotes] = useState(null);
const invoice = useSelector( (state) => state.invoices.invoice );

const handleChangeValue = (e) => {
    setResponse(e.target.value);
}
const handleAddNotes = (e) => {
    setNotes(e.target.value);
}

const handleSubmit = (e) => {
    e.preventDefault();
    const message = "Invoice successfully closed";
    props.handleResponseSubmit({stage: "AC", notes: notes}, message);
}

    return (
        <form onSubmit={(e) => handleSubmit(e)} className="gap-above-m gap-below-s">
            <div className={response === "received" ? "typical-radio checked" : "typical-radio"} >
                <input type="radio" id="received" name="receipt" value="received" onChange={(e) => handleChangeValue(e)} checked={response === "received"}/>
                <label className="content2" htmlFor="received"> Per adjudication results, payment has been received in full</label>
            </div>
            <div className={response === "notreceived" ? "typical-radio checked gap-below-xs" : "typical-radio gap-below-xs"} >
                <input type="radio" id="notreceived" name="receipt" value="notreceived" onChange={(e) => handleChangeValue(e)} checked={response === "notreceived"}/>
                <label className="content2" htmlFor="notreceived"> Per adjudication results, no payment will be made</label>
            </div>
            <div className="gap-above-s gap-below-s">
                <p className="content2 heavy-grey gap-below-xs">Supporting Documents</p>
                <Addfiles 
                    uploadTitle="+ Add Supporting Docs"
                    selectedFiles={props.selectedFilesAdditional}
                    handleDrop={props.handleDrop}
                    removeSelectedFile={props.removeSelectedFile}
                    maxSize={10485760}
                    maxFiles={0}
                    multiple={true}
                    accept=""
                />
            </div>
            <div className="inputs-wrapper" >
                <div className="input-basic addspace textarea">	
                    <label className="textarea" htmlFor="notes">Notes (optional)</label>	
                    <textarea type="text" name="notes" id="notes" rows="3" onChange={(e) => handleAddNotes(e)}/>
                </div>
            </div>
            <div className="gap-above-s">
                <button id="invoice_close" className="btn pri min-width" type="submit" disabled={!response || props.isSubmitting} >{props.isSubmitting ? "Please wait..." : "Close Invoice"}</button>
            </div>
        </form> 
    )
}


const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(InvoiceStep4CloseAdjudication);